window.SodaFlutterBridge = (function () {
  if (!window.__SodaFlutterBridge__) return null
  if (window.Soda.setTitle) delete Soda.setTitle
  const bridge = {}
  let callbackId = 0
  const _cacheBridgeCallback = {}
  const BASIC_PARAMS = '__basic_params__'

  const __invokeMethod = function (_callbackId, method, params, callback) {
    return new Promise(function (resolve, reject) {
      _cacheBridgeCallback[_callbackId] = response => {
        try {
          console.log(
            'response back ' + method + ',' + JSON.stringify(response),
            'callback',
            _callbackId,
          )
          callback(response)
          resolve(response)
        } catch (e) {
          console.log('response back error ' + method + e.message)
          reject(e)
        }
      }
      if (typeof params !== 'object') {
        /// 兼容params 直接传入基础数据类型的方式
        params = { [BASIC_PARAMS]: params }
      }
      const message = {
        action: method,
        callbackId: _callbackId,
        params,
      }
      console.log('sendMessage' + JSON.stringify(message))
      window.__SodaFlutterBridge__.postMessage(JSON.stringify(message))
    })
  }
  const empty = () => {}

  bridge.invokeMethod = function (method, params, callback) {
    const _callbackId = 'callbackId' + callbackId++
    let _params = typeof params !== 'undefined' ? params : {}
    let _callback = callback || empty
    if (typeof params === 'function') {
      _callback = params
      _params = {}
    }
    // 将params里面的方法转化成字符串
    for (const key in _params) {
      if (params[key] instanceof Function) {
        const keyFunName = '__callback_' + _callbackId + '_' + key
        _cacheBridgeCallback[keyFunName] = params[key]
        params[key] = keyFunName
      }
    }
    console.log('invoke ' + method + ',' + _params, 'callbackId', _callbackId)
    return __invokeMethod(_callbackId, method, _params, _callback)
  }
  window.__SodaFlutterBridge__.callCallback = function (funName, params, isDelete) {
    const fun = _cacheBridgeCallback[funName]
    let rs = {}
    if (fun) {
      try {
        // rs = fun.call(null, params)
        rs = fun.call({}, params)
      } catch (e) {}
      // 默认删除
      if (isDelete === 1) {
        delete _cacheBridgeCallback[funName]
      }
    }

    return JSON.stringify({
      data: rs,
    })
  }
  ///   {
  ///     "callbackId":"",
  ///     "eventName":"", // 事件名称
  ///     "errNo": 0,/// 0:成功 1:失败 2:不存在bridge方法
  ///     "message":"", // 失败原因
  ///     "data":{}, // 返回数据
  ///   }
  window.__SodaFlutterBridge__.receiveMessage = function (message) {
    const callbackId = message.callbackId
    const _responseMessage = {
      errNo: message.error,
      data: message.data,
      message: message.message,
    }
    let rs = null
    try {
      console.log('[log] _cacheBridgeCallback', _cacheBridgeCallback)
      if (_cacheBridgeCallback[callbackId]) {
        rs = _cacheBridgeCallback[callbackId](_responseMessage)
        delete _cacheBridgeCallback[callbackId]
      }
    } catch (e) {
      console.log(e.message)
    }
    return rs
  }
  return bridge
})()

window.loadFlutterBridge = () => {
  if (!window.Soda) window.Soda = {}
  const bridgeList = [
    'setBackPressListener',
    'addPhotoBridge',
    'openThirdApp',
    'openAppSetting',
    'getStatusBarHeight',
    'getGlobalParams',
    'exitApp',
    'setTitle',
    'openPage',
    'closePage',
    'toggleTitleBar',
    'goBack',
    'showNavigationBarRightItem',
    'goStoreList',
    'copyText',
  ]
  bridgeList.forEach(key => {
    if (!window.Soda[key]) {
      window.Soda[key] = (params, callback) => {
        if (key === 'toggleTitleBar') params = { type: params }
        try {
          return window.SodaFlutterBridge.invokeMethod(key, params, callback)
        } catch (e) {
          console.error('[log] invoke bridge ' + key + 'failed', e)
        }
      }
    }
  })
}
if (navigator.userAgent === 'BDApp FlutterWebView') {
  window.isFlutterWebview = true
  window.loadFlutterBridge()
}
